import React from 'react';
import { Route } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { RoutePathProps } from '../../../../AppRoutes/types';
import ProfilePage from '../pages/ProfilePage';
// import EditProduct from '../pages/EditProduct';

const profile: RoutePathProps = {
  name: "profile",
  path: "/profile",
  label: "Profile",
  icon: AccountCircleIcon,
  visibleInNav: false,
  requiredPermission:'profile:read',
  children: [
    // {
    //   name: "profile",
    //   path: "/profile/:id",
    //   label: "Profile",
    //   icon: AccountCircleIcon,
    // }
  ],
};

const ProfileRoutes = (
  <>
    <Route path={profile.path} element={<ProfilePage />} />
    {/* <Route path={profile.children?.[0].path} element={<ProfilePage />} /> */}
  </>
);
export const profilePaths = [profile];
export default ProfileRoutes;
